module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAiCAYAAADVhWD8AAAACXBIWXMAAAsSAAALEgHS3X78AAABHElEQVRYhcXYUQqCQBDG8Y9O0A3qBnmjrtQRPIpHCIKeu0DgU6//HlIyWXV3Z3caEAWF78c4uIsCBOyBdjjL+bgADaARcuVTV2dQO+T2QLPTb50kdZL2ql+tpPNw/ZD0GIXT7nh0qP1GfbOmD3iBgpA5xgO0CAlhaoJWIUuYGqBNyBqmJCgKsoUpAYqGxGAsoCRILCYHlAxJwaSAsiCpmBhQNiQHswYyQXIxIdDTCrFgQiCAWy4E0HwLkVK9pLtxG/Fbhs5MZ+T1z9c0H9YDBZaOEpAx1LyWlYIsDXW1j94WxAwqDTGBakCyQbUgWaCakGRQbUgSyAMSDfKCRIE8IZsgb8gqSMCRzy8JL0gI1APNeKMBOkfIFNQN+XoDXKLuzg9i/+4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/UI/Recurso 33.png
// module id = MP6W
// module chunks = 0